export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const MAX_TOTAL_UPLOAD_SIZE_BYTES = 30 * 1024 * 1024;

const formatMegabytes = (bytes) => `${Math.round(bytes / 1024 / 1024)}MB`;

export const validateSelectedFiles = (files) => {
  const selectedFiles = Array.from(files || []);
  const oversizedFile = selectedFiles.find(
    (file) => file.size > MAX_FILE_SIZE_BYTES
  );

  if (oversizedFile) {
    return {
      valid: false,
      message: `「${oversizedFile.name}」は${formatMegabytes(MAX_FILE_SIZE_BYTES)}を超えています。ファイルサイズを小さくしてから選択してください。`,
    };
  }

  const totalSize = selectedFiles.reduce((sum, file) => sum + file.size, 0);
  if (totalSize > MAX_TOTAL_UPLOAD_SIZE_BYTES) {
    return {
      valid: false,
      message: `一度に選択できるファイルの合計サイズは${formatMegabytes(MAX_TOTAL_UPLOAD_SIZE_BYTES)}までです。`,
    };
  }

  return { valid: true, files: selectedFiles };
};
